import { createMessage, registerComponent } from "helpers";
import WYATTElement from "wyatt";

/**
 * @param {string} raw
 * @returns {string | null} 5 digits or null if invalid
 */
function normalizeAndValidateZip(raw) {
  const digits = raw.trim().replace(/\D/g, "");

  if (digits.length === 5) {
    return digits;
  }

  return null;
}

registerComponent(
  "location-search-form",
  class LocationSearchForm extends WYATTElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      this.input = this.querySelector('input[name="zip"]');
      this.inputWrapper = this.querySelector(
        ".location-search-form__input-wrapper",
      );
      this.clearButton = this.querySelector("[data-location-search-clear]");

      this.handleInput = this.handleInput.bind(this);
      this.handleClear = this.handleClear.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.geolocationButton = this.querySelector("[data-geolocation-button]");
    }

    get cartZip() {
      try {
        return WYATT.shopify?.cart?.attributes?.location?.zip || "";
      } catch {
        return "";
      }
    }

    connectedCallback() {
      if (!this.input || !this.form) {
        return;
      }

      if (this.cartZip) {
        const digits = String(this.cartZip).replace(/\D/g, "");
        this.input.value = digits.length >= 5 ? digits.slice(0, 5) : digits;
      }

      this.syncClearButton();
      this.input.addEventListener("input", this.handleInput);
      this.clearButton?.addEventListener("click", this.handleClear);
      this.form.addEventListener("submit", this.handleSubmit);
      this.geolocationButton?.addEventListener("click", this.handleGeolocation);
    }

    handleInput() {
      this.input.classList.remove("text-box--invalid");
      this.input.setAttribute("aria-invalid", "false");
      this.syncClearButton();
    }

    handleClear(event) {
      event.preventDefault();

      if (!this.input) {
        return;
      }

      this.input.value = "";
      this.input.classList.remove("text-box--invalid");
      this.input.setAttribute("aria-invalid", "false");
      this.input.focus();
      this.syncClearButton();
    }

    async handleSubmit(event) {
      event.preventDefault();

      if (!this.input) {
        return;
      }

      const zip = normalizeAndValidateZip(this.input.value);

      if (!zip) {
        this.input.classList.add("text-box--invalid");
        this.input.setAttribute("aria-invalid", "true");
        createMessage(WYATT.t.locationSearchForm.invalidZip, { type: "error" });
        this.input.focus();

        return;
      }

      this.input.classList.remove("text-box--invalid");
      this.input.setAttribute("aria-invalid", "false");
      await WYATT.Geolocation.updateLocationFromZip(zip);
    }

    syncClearButton() {
      if (!this.clearButton || !this.input) {
        return;
      }

      if (this.input.value.length > 0) {
        this.clearButton.classList.remove("hidden");
        this.inputWrapper?.classList.add(
          "location-search-form__input-wrapper--has-value",
        );
      } else {
        this.clearButton.classList.add("hidden");
        this.inputWrapper?.classList.remove(
          "location-search-form__input-wrapper--has-value",
        );
      }
    }

    handleGeolocation(event) {
      event.preventDefault();

      WYATT.Geolocation.updateLocationFromUser();
    }
  },
);
